@let stockAmount = this.stockAmount();
<div class="flex flex-col justify-center items-end">
  <div class="flex flex-row flex-nowrap items-center text-xl">
    <span>{{stockAmount.menge | format:'NUMBER.DEFAULT'}}</span>

    @if (hideUnit()) {
      @if (stockAmount.menge_lg !== stockAmount.menge) {
        <span class="ml-1">EH</span>
      } @else {
        <span class="ml-1">{{stockAmount.einheit_lg.arteh}}</span>
      }
    } @else {
      <span class="ml-1">{{stockAmount.einheit.arteh}}</span>
    }
  </div>
  @if (stockAmount.einheit.id !== stockAmount.einheit_lg.id && !(hideUnit() && stockAmount.menge_lg === stockAmount.menge)) {
    <div class="flex flex-row flex-nowrap color-light items-center text-xl">
      <span class="whitespace-nowrap text-sm">= {{stockAmount.menge_lg}}</span>
      <span class="ml-1 text-sm">{{stockAmount.einheit_lg.arteh}}</span>
    </div>
  }
</div>
